import { GridActionHandlerBase } from "./grid-action-handler-base";

/**
 * Triggers the show all action of the grid
 */
export class ShowAllGridActionHandler extends GridActionHandlerBase {
  /**
  * Handles an event
  * @param _payload The (untyped) payload. Can also be a callback function
  */
  public handle(_payload: any): void{
    this.workspace.grid.showAll(null);
  }
}
